{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "Enganxa",
    "pasteAsPlaintext": "Enganxar com a text pla",
    "pasteCharts": "Enganxa els diagrames",
    "chartType_bar": "",
    "chartType_line": "",
    "chartType_radar": "",
    "chartType_plaintext": "",
    "selectAll": "Selecciona-ho tot",
    "multiSelect": "Afegeix un element a la selecció",
    "moveCanvas": "Mou el llenç",
    "cut": "Retalla",
    "copy": "Copia",
    "copyAsPng": "Copia al porta-retalls com a PNG",
    "copyAsSvg": "Copia al porta-retalls com a SVG",
    "copyText": "Copia al porta-retalls com a text",
    "copySource": "Copia al porta-retalls",
    "convertToCode": "Converteix a codi",
    "bringForward": "Porta endavant",
    "sendToBack": "Envia enrere",
    "bringToFront": "Porta al davant",
    "sendBackward": "Envia al fons",
    "delete": "Elimina",
    "copyStyles": "Copia els estils",
    "pasteStyles": "Enganxa els estils",
    "stroke": "Color del traç",
    "changeStroke": "Canvia el color del traç",
    "background": "Color del fons",
    "changeBackground": "Canvia el color de fons",
    "fill": "Estil del fons",
    "strokeWidth": "Amplada del traç",
    "strokeStyle": "Estil del traç",
    "strokeStyle_solid": "Sòlid",
    "strokeStyle_dashed": "Guions",
    "strokeStyle_dotted": "Punts",
    "sloppiness": "Estil del traç",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "Opacitat",
    "textAlign": "Alineació del text",
    "edges": "Vores",
    "sharp": "Agut",
    "round": "Arrodonit",
    "arrowheads": "Puntes de fletxa",
    "arrowhead_none": "Cap",
    "arrowhead_arrow": "Fletxa",
    "arrowhead_bar": "Barra",
    "arrowhead_circle": "Cercle",
    "arrowhead_circle_outline": "Circumferència",
    "arrowhead_triangle": "Triangle",
    "arrowhead_triangle_outline": "Triangle (vora)",
    "arrowhead_diamond": "Rombe",
    "arrowhead_diamond_outline": "Rombe (vora)",
    "arrowhead_crowfoot_many": "Potes de gall (moltes)",
    "arrowhead_crowfoot_one": "Potes de gall (una)",
    "arrowhead_crowfoot_one_or_many": "Potes de gall (una o moltes)",
    "arrowhead_cardinality_one": "",
    "arrowhead_cardinality_many": "",
    "arrowhead_cardinality_one_or_many": "",
    "arrowhead_cardinality_exactly_one": "",
    "arrowhead_cardinality_zero_or_one": "",
    "arrowhead_cardinality_zero_or_many": "",
    "more_options": "Més opcions",
    "cardinality": "",
    "arrowtypes": "Tipus de fletxa",
    "arrowtype_sharp": "Fletxa Esmolada",
    "arrowtype_round": "Fletxa corba",
    "arrowtype_elbowed": "Fletxa de colzes",
    "fontSize": "Mida de lletra",
    "fontFamily": "Tipus de lletra",
    "addWatermark": "Afegeix-hi «Fet amb Excalidraw»",
    "handDrawn": "Dibuixat a mà",
    "normal": "Normal",
    "code": "Codi",
    "small": "Petit",
    "medium": "Mitjà",
    "large": "Gran",
    "veryLarge": "Molt gran",
    "solid": "Sòlid",
    "hachure": "Ratlletes",
    "zigzag": "Ziga-zaga",
    "crossHatch": "Ratlletes creuades",
    "thin": "Fi",
    "bold": "Negreta",
    "left": "Esquerra",
    "center": "Centre",
    "right": "Dreta",
    "extraBold": "Extra negreta",
    "architect": "Arquitecte",
    "artist": "Artista",
    "cartoonist": "Dibuixant",
    "fileTitle": "Nom del fitxer",
    "colorPicker": "Selector de colors",
    "canvasColors": "Usat al llenç",
    "canvasBackground": "Fons del llenç",
    "drawingCanvas": "Llenç de dibuix",
    "clearCanvas": "Neteja el llenç",
    "layers": "Capes",
    "actions": "Accions",
    "language": "Llengua",
    "liveCollaboration": "Col·laboració en directe...",
    "duplicateSelection": "Duplica",
    "untitled": "Sense títol",
    "name": "Nom",
    "yourName": "El vostre nom",
    "madeWithExcalidraw": "Fet amb Excalidraw",
    "group": "Agrupa la selecció",
    "ungroup": "Desagrupa la selecció",
    "collaborators": "Col·laboradors",
    "you": "",
    "toggleGrid": "Alterna la quadrícula",
    "loadingScene": "S'està carregant l'escena…",
    "loadScene": "Carrega una escena des d'un fitxer",
    "align": "Alinea",
    "alignTop": "Alinea a la part superior",
    "alignBottom": "Alinea a la part inferior",
    "alignLeft": "Alinea a l’esquerra",
    "alignRight": "Alinea a la dreta",
    "centerVertically": "Centra verticalment",
    "centerHorizontally": "Centra horitzontalment",
    "distributeHorizontally": "Distribueix horitzontalment",
    "distributeVertically": "Distribueix verticalment",
    "flipHorizontal": "Capgira horitzontalment",
    "flipVertical": "Capgira verticalment",
    "viewMode": "Mode de visualització",
    "share": "Comparteix",
    "showStroke": "Mostra el selector de color del traç",
    "showBackground": "Mostra el selector de color de fons",
    "showFonts": "Mostra el selector tipogràfic",
    "toggleTheme": "Alternar tema clar i fosc",
    "theme": "Tema",
    "decreaseFontSize": "Redueix la mida de la lletra",
    "increaseFontSize": "Augmenta la mida de la lletra",
    "unbindText": "Desvincular el text",
    "bindText": "Ajusta el text al contenidor",
    "createContainerFromText": "Ajusta el text al contenidor",
    "link": {
      "edit": "Edita l'enllaç",
      "editEmbed": "Editar enllaç incrustable",
      "create": "Afegir un enllaç",
      "label": "Enllaç",
      "labelEmbed": "Enllaça i encasta",
      "empty": "No s'ha definit cap enllaç",
      "hint": "Escriu o enganxa un enllaç aquí",
      "goToElement": "Anar a l'element objectiu"
    },
    "lineEditor": {
      "edit": "Editar línia",
      "editArrow": "Edita la fletxa"
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "Bloca",
      "unlock": "Desbloca",
      "lockAll": "Bloca-ho tot",
      "unlockAll": "Desbloca-ho tot"
    },
    "sidebarLock": "Manté la barra lateral oberta",
    "selectAllElementsInFrame": "Selecciona tots els elements del marc",
    "removeAllElementsFromFrame": "Elimina tots els elements del marc",
    "eyeDropper": "Tria un color del llenç",
    "followUs": "Seguiu-nos",
    "discordChat": "Xat de Discord",
    "zoomToFitViewport": "Amplia per adaptar-se a la finestra",
    "zoomToFitSelection": "Zoom per veure la selecció",
    "zoomToFit": "Zoom per veure tots els elements",
    "installPWA": "Instal·la Excalidraw localment (PWA)",
    "autoResize": "Activa la redimensió de text automàtica",
    "imageCropping": "Retallar la imatge",
    "unCroppedDimension": "Dimensió sense retallar",
    "copyElementLink": "Copiar enllaç a objecte",
    "linkToElement": "Enllaç a l'objecte",
    "wrapSelectionInFrame": "Embolica la selecció en un marc",
    "tab": "",
    "shapeSwitch": "",
    "preferences": "",
    "preferences_toolLock": "",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "",
    "midpointSnapping": ""
  },
  "elementLink": {
    "title": "Enllaç a l'objecte",
    "desc": "Fes clic en una forma al llenç o enganxa un enllaç.",
    "notFound": "L'objecte enllaçat no s'ha trobat al llenç."
  },
  "search": {
    "title": "Troba al llenç",
    "noMatch": "No hem trobat coincidències...",
    "singleResult": "resultat",
    "multipleResults": "resultats",
    "placeholder": "Troba al llenç...",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "Neteja el llenç",
    "exportJSON": "Exporta a un fitxer",
    "exportImage": "Exporta la imatge...",
    "export": "Guardar a...",
    "copyToClipboard": "Copia al porta-retalls",
    "copyLink": "Copia l'enllaç",
    "save": "Desa al fitxer actual",
    "saveAs": "Anomena i desa",
    "load": "Obrir",
    "getShareableLink": "Obté l'enllaç per a compartir",
    "close": "Tanca",
    "selectLanguage": "Trieu la llengua",
    "scrollBackToContent": "Torna al contingut",
    "zoomIn": "Apropa't",
    "zoomOut": "Allunya't",
    "resetZoom": "Restableix el zoom",
    "menu": "Menú",
    "done": "Fet",
    "edit": "Edita",
    "undo": "Desfés",
    "redo": "Refés",
    "createNewRoom": "Crea una sala nova",
    "fullScreen": "Pantalla completa",
    "darkMode": "Mode fosc",
    "lightMode": "Mode clar",
    "systemMode": "Mode del sistema",
    "zenMode": "Mode zen",
    "objectsSnapMode": "Ajusta als objectes",
    "exitZenMode": "Surt de mode zen",
    "cancel": "Cancel·la",
    "clear": "Neteja",
    "remove": "Suprimeix",
    "embed": "Commuta incrustació",
    "submit": "Envia",
    "confirm": "Confirma",
    "embeddableInteractionButton": "Feu clic per interactuar"
  },
  "alerts": {
    "clearReset": "S'esborrarà tot el llenç. N'esteu segur?",
    "couldNotCreateShareableLink": "No s'ha pogut crear un enllaç per a compartir.",
    "couldNotCreateShareableLinkTooBig": "No s’ha pogut crear un enllaç per a compartir: l’escena és massa gran",
    "couldNotLoadInvalidFile": "No s'ha pogut carregar un fitxer no vàlid",
    "importBackendFailed": "Importació fallida.",
    "cannotExportEmptyCanvas": "No es pot exportar un llenç buit.",
    "couldNotCopyToClipboard": "No s'ha pogut copiar al porta-retalls.",
    "decryptFailed": "No s'ha pogut desencriptar.",
    "uploadedSecurly": "La càrrega s'ha assegurat amb xifratge punta a punta, cosa que significa que el servidor Excalidraw i tercers no poden llegir el contingut.",
    "loadSceneOverridePrompt": "Si carregas aquest dibuix extern, substituirá el que tens. Vols continuar?",
    "collabStopOverridePrompt": "Aturar la sessió provocarà la sobreescriptura del dibuix previ, que hi ha desat en l'emmagatzematge local. N'esteu segur?\n\n(Si voleu conservar el dibuix local, tanqueu la pentanya del navegador en comptes d'aturar la sessió).",
    "imageDoesNotContainScene": "Aquesta imatge no sembla contenir cap dada d'escena. Heu activat l'incrustació de l'escena durant l'exportació?",
    "cannotRestoreFromImage": "L’escena no s’ha pogut restaurar des d’aquest fitxer d’imatge",
    "invalidSceneUrl": "No s'ha pogut importar l'escena des de l'adreça URL proporcionada. Està malformada o no conté dades Excalidraw JSON vàlides.",
    "invalidEncryptionKey": "La clau d'encriptació ha de tenir 22 caràcters. La col·laboració en directe està desactivada.",
    "collabOfflineWarning": "Sense connexió a internet disponible.\nEls vostres canvis no seran guardats!",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "Tipus de fitxer no suportat.",
    "imageInsertError": "No s'ha pogut insertar la imatge, torneu-ho a provar més tard...",
    "fileTooBig": "El fitxer és massa gros. La mida màxima permesa és {{maxSize}}.",
    "svgImageInsertError": "No ha estat possible inserir la imatge SVG. Les marques SVG semblen invàlides.",
    "failedToFetchImage": "No s'ha pogut obtenir la imatge.",
    "cannotResolveCollabServer": "No ha estat possible connectar amb el servidor collab. Si us plau recarregueu la pàgina i torneu a provar.",
    "collabSaveFailed": "No s'ha pogut desar a la base de dades de fons. Si els problemes persisteixen, hauríeu de desar el fitxer localment per assegurar-vos que no perdeu el vostre treball.",
    "collabSaveFailed_sizeExceeded": "No s'ha pogut desar a la base de dades de fons, sembla que el llenç és massa gran. Hauríeu de desar el fitxer localment per assegurar-vos que no perdeu el vostre treball.",
    "imageToolNotSupported": "Les imatges no estan habilitades.",
    "brave_measure_text_error": {
      "line1": "Sembla que feu servir el navegador Brave amb el <bold>blocatge agressiu d'indentificació única</bold> activat.",
      "line2": "Això podria provocar problemes amb els <bold>elements de text</bold> en els vostres dissenys.",
      "line3": "Us recomanem encaridament que desactiveu aquesta característica. Podeu seguir <link>aquests passos</link> per a fer-ho.",
      "line4": "Si els elements de text no es mostren correctament malgrat haver desactivat aquesta opció, si us plau, obriu una <issueLink>incidència</issueLink> a la nostra pàgina de GitHub o escriviu-nos a <discordLink>Discord</discordLink>"
    },
    "asyncPasteFailedOnRead": "No s'ha pogut enganxar (no s'ha pogut llegir del porta-retalls del sistema).",
    "asyncPasteFailedOnParse": "No s'ha pogut enganxar.",
    "copyToSystemClipboardFailed": "No s'ha pogut copiar al porta-retalls."
  },
  "toolBar": {
    "selection": "Selecció",
    "lasso": "",
    "image": "Insereix imatge",
    "rectangle": "Rectangle",
    "diamond": "Rombe",
    "ellipse": "El·lipse",
    "arrow": "Fletxa",
    "line": "Línia",
    "freedraw": "Dibuix",
    "text": "Text",
    "lock": "Mantenir activa l'eina seleccionada desprès de dibuixar",
    "penMode": "Mode de llapis - evita tocar",
    "link": "Afegeix/actualitza l'enllaç per a una forma seleccionada",
    "eraser": "Esborrador",
    "frame": "Eina de marc",
    "embeddable": "Incrustació Web",
    "laser": "Punter làser",
    "autoshape": "",
    "bucketfill": "",
    "hand": "Mà (eina de desplaçament)",
    "extraTools": "Més eines",
    "convertElementType": ""
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "Rectangle",
    "diamond": "Rombe",
    "ellipse": "El·lipse",
    "arrow": "Fletxa",
    "line": "Línia",
    "freedraw": "Dibuix a mà alçada",
    "text": "Text",
    "image": "Imatge",
    "group": "Grup",
    "frame": "Marc",
    "embeddable": "Incrustació Web",
    "selection": "Selecció",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "Accions del llenç",
    "selectedShapeActions": "Accions per a les formes seleccionades",
    "shapes": "Formes"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "Feu clic per a dibuixar múltiples punts; arrossegueu per a una sola línia",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "Feu clic i arrossegueu, deixeu anar per a finalitzar",
    "text": "Consell: també podeu afegir text fent doble clic en qualsevol lloc amb l'eina de selecció",
    "embeddable": "Feu clic i arrossegueu per crear una Incrustació Web",
    "autoshape": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "toggleArrowhead": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "És probable que aquesta funció es pugui activar posant la marca \"dom.events.asyncClipboard.clipboardItem\" a \"true\". Per canviar les marques del navegador al Firefox, visiteu la pàgina \"about:config\".",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "No es pot mostrar la previsualització",
    "canvasTooBig": "Pot ser que el llenç sigui massa gran.",
    "canvasTooBigTip": "Consell: proveu d’acostar una mica els elements més allunyats."
  },
  "errorSplash": {
    "headingMain": "S'ha produït un error. Proveu <button>recarregar la pàgina.</button>",
    "clearCanvasMessage": "Si la recàrrega no funciona, proveu <button>esborrar el llenç.</button>",
    "clearCanvasCaveat": " Això resultarà en la pèrdua de feina ",
    "trackedToSentry": "L'error amb l'identificador {{eventId}} s'ha rastrejat en el nostre sistema.",
    "openIssueMessage": "Anàvem amb molta cura de no incloure la informació de la vostra escena en l'error. Si l'escena no és privada, podeu fer-ne el seguiment al nostre <button>rastrejador d'errors.</button> Incloeu la informació a continuació copiant i enganxant a GitHub Issues.",
    "sceneContent": "Contingut de l'escena:"
  },
  "shareDialog": {
    "or": "O"
  },
  "roomDialog": {
    "desc_intro": "Convideu gent a col·laborar en el vostre disseny.",
    "desc_privacy": "No us amoïneu, la sessió està encriptada d'extrem a extrem i és totalment privada. Ni tan sols el nostre servidor pot veure què dibuixeu.",
    "button_startSession": "Inicia la sessió",
    "button_stopSession": "Atura la sessió",
    "desc_inProgressIntro": "La sessió de col·laboració en directe està en marxa.",
    "desc_shareLink": "Comparteix aquest enllaç amb qualsevol persona amb qui vulgueu col·laborar:",
    "desc_exitSession": "Si atureu la sessió, us desconectareu de la sala, però podreu continuar treballant amb el dibuix localment. Tingues en compte que això no afectarà a altres persones, i encara podran col·laborar en la seva versió.",
    "shareTitle": "Uniu-vos a una sessió de col·laboració en directe a Excalidraw"
  },
  "errorDialog": {
    "title": "Error"
  },
  "progressDialog": {
    "title": "",
    "defaultMessage": ""
  },
  "exportDialog": {
    "disk_title": "Desa al disc",
    "disk_details": "Exporta les dades de l'escena a un fitxer que després podreu importar.",
    "disk_button": "Desa en un fitxer",
    "link_title": "Enllaç per a compartir",
    "link_details": "Exporta com a un enllaç de només lectura.",
    "link_button": "Exporta a un enllaç",
    "excalidrawplus_description": "Desa l'escena en el vostre espai de treball Excalidraw+.",
    "excalidrawplus_button": "Exporta",
    "excalidrawplus_exportError": "No és possible exportar a Excalidraw+ ara mateix..."
  },
  "helpDialog": {
    "blog": "Llegiu el nostre blog",
    "click": "clic",
    "deepSelect": "Selecció profunda",
    "deepBoxSelect": "Seleccioneu profundament dins del quadre i eviteu arrossegar",
    "createFlowchart": "Crear un diagrama de flux a partir d'un element genèric",
    "navigateFlowchart": "Navegar per un diagrama de flux",
    "curvedArrow": "Fletxa corba",
    "curvedLine": "Línia corba",
    "documentation": "Documentació",
    "doubleClick": "doble clic",
    "drag": "arrossega",
    "editor": "Editor",
    "editLineArrowPoints": "Edita els punts de la línia/fletxa",
    "editText": "Edita text / afegeix etiqueta",
    "github": "Hi heu trobat un problema? Informeu-ne",
    "howto": "Seguiu les nostres guies",
    "or": "o",
    "preventBinding": "Prevenir vinculació de la fletxa",
    "tools": "Eines",
    "shortcuts": "Dreceres de teclat",
    "textFinish": "Finalitza l'edició (editor de text)",
    "textNewLine": "Afegeix una línia nova (editor de text)",
    "title": "Ajuda",
    "view": "Visualització",
    "zoomToFit": "Zoom per veure tots els elements",
    "zoomToSelection": "Zoom per veure la selecció",
    "toggleElementLock": "Blocar/desblocar la selecció",
    "movePageUpDown": "Mou la pàgina cap amunt/a baix",
    "movePageLeftRight": "Mou la pàgina cap a l'esquerra/dreta",
    "cropStart": "Retallar l'imatge",
    "cropFinish": "Finalitza el retall d'imatge"
  },
  "clearCanvasDialog": {
    "title": "Neteja el llenç"
  },
  "imageExportDialog": {
    "header": "Exporteu la imatge",
    "label": {
      "withBackground": "Fons",
      "onlySelected": "Només seleccionat",
      "darkMode": "Mode fosc",
      "embedScene": "Incrusta escena",
      "scale": "Escala",
      "padding": "Marge intern (padding)"
    },
    "tooltip": {
      "embedScene": "Les dades de l’escena es desaran al fitxer PNG/SVG de manera que es pugui restaurar l’escena.\nAixò farà augmentar la mida del fitxer exportat."
    },
    "title": {
      "exportToPng": "Exporteu a PNG",
      "exportToSvg": "Exporteu a SVG",
      "copyPngToClipboard": "Copieu el PNG al porta-retalls"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Copieu al porta-retalls"
    }
  },
  "encrypted": {
    "tooltip": "Els vostres dibuixos estan xifrats de punta a punta de manera que els servidors d’Excalidraw no els veuran mai.",
    "link": "Article del blog sobre encriptació d'extrem a extrem a Excalidraw"
  },
  "stats": {
    "angle": "Angle",
    "shapes": "Formes",
    "height": "Altura",
    "scene": "Escena",
    "selected": "Seleccionat",
    "storage": "Emmagatzematge",
    "fullTitle": "Propietats del Llenç i de la Forma",
    "title": "Propietats",
    "generalStats": "General",
    "elementProperties": "Propietats de la forma",
    "total": "Total",
    "version": "Versió",
    "versionCopy": "Feu clic per a copiar",
    "versionNotAvailable": "Versió no disponible",
    "width": "Amplada"
  },
  "toast": {
    "copyStyles": "S'han copiat els estils.",
    "copyToClipboard": "S'ha copiat al porta-retalls.",
    "copyToClipboardAsPng": "S'ha copiat {{exportSelection}} al porta-retalls en format PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "S'ha copiat {{exportSelection}} al porta-retalls com a SVG\n({{exportColorScheme}})",
    "fileSaved": "S'ha desat el fitxer.",
    "fileSavedToFilename": "S'ha desat a {filename}",
    "canvas": "el llenç",
    "selection": "la selecció",
    "pasteAsSingleElement": "Fer servir {{shortcut}} per enganxar com un sol element,\no enganxeu-lo en un editor de text existent",
    "unableToEmbed": "Actualment no es permet incrustar aquesta URL. Planteja un problema a GitHub per sol·licitar que l'URL estigui a la llista blanca",
    "unrecognizedLinkFormat": "L'enllaç que has incrustat no coincideix amb el format esperat. Si us plau, intenta enganxar l'enllaç 'embed' proporcionada pel lloc web d'origen",
    "elementLinkCopied": "Enllaç copiat al porta-retalls"
  },
  "colors": {
    "transparent": "Transparent",
    "black": "Negre",
    "white": "Blanc",
    "red": "Vermell",
    "pink": "Rosa",
    "grape": "Violat (raïm)",
    "violet": "Violat",
    "gray": "Gris",
    "blue": "Blau",
    "cyan": "Cian",
    "teal": "Xarxet",
    "green": "Verd",
    "yellow": "Groc",
    "orange": "Taronja",
    "bronze": "Bronze"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "Vols anar a Excalidraw+ en comptes?",
      "menuHint": "Exportar, preferències, llenguatges..."
    },
    "defaults": {
      "menuHint": "Exportar, preferències i més...",
      "center_heading": "Diagrames. Fer. Simple.",
      "toolbarHint": "Selecciona una eina i comença a dibuixar!",
      "helpHint": "Dreceres i ajuda"
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "Colors personalitzats més usats",
    "colors": "Colors",
    "shades": "Ombres",
    "hexCode": "Codi hexadecimal",
    "noShades": "No hi ha ombres disponibles per a aquest color",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Exporteu com a imatge",
        "button": "Exporteu com a imatge",
        "description": "Exporta les dades de l'escena com una imatge des de la qual podràs importar-les més tard."
      },
      "saveToDisk": {
        "title": "Deseu al disc",
        "button": "Deseu al disc",
        "description": "Exporta les dades de l'escena a un fitxer des del qual podràs importar-les més tard."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Exporta a Excalidraw+",
        "description": "Desa l'escena al teu espai de treball d'Excalidraw+."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Carrega des d'un fitxer",
        "button": "Carrega des d'un fitxer",
        "description": "Carregar des d'un fitxer <bold>substituirà el contingut actual</bold>.<br></br>Podeu desar el vostre disseny abans fent servir una de les opcions més avall."
      },
      "shareableLink": {
        "title": "Carrega des d'un enllaç",
        "button": "Substitueix el contingut",
        "description": "Carregar un disseny extern <bold>substituirà el contingut actual</bold>.<br></br>Podeu desar el vostre disseny abans fent servir una de les opcions més avall."
      }
    }
  },
  "quickSearch": {
    "placeholder": "Cerca ràpida"
  },
  "fontList": {
    "badge": {
      "old": "antic"
    },
    "sceneFonts": "En aquesta escena",
    "availableFonts": "Lletres tipogràfiques disponibles",
    "empty": "No s'ha trobat cap lletra tipogràfica"
  },
  "userList": {
    "empty": "No s'ha trobat cap usuari",
    "hint": {
      "text": "Feu clic sobre un usuari per seguir-lo",
      "followStatus": "Ara per ara seguiu aquest usuari",
      "inCall": "L'usuari es troba en una trucada de veu",
      "micMuted": "El micròfon de l'usuari és silenciat",
      "isSpeaking": "L'usuari parla ara"
    }
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
